import { render, staticRenderFns } from "./GameLink.vue?vue&type=template&id=4bb5ec3e&scoped=true"
import script from "./GameLink.vue?vue&type=script&lang=js"
export * from "./GameLink.vue?vue&type=script&lang=js"
import style0 from "./GameLink.vue?vue&type=style&index=0&id=4bb5ec3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb5ec3e",
  null
  
)

export default component.exports